import { FC } from 'react';
import {
  GMB_FACEBOOK_LINK,
  GMB_INSTAGRAM_LINK,
  GMB_LINKEDIN_LINK,
  GMB_PINTEREST_LINK,
  GMB_TIKTOK_LINK,
  GMB_TWITTER_LINK,
  GMB_YOUTUBE_LINK,
  NEW_TAB_ATTRIBUTES,
} from 'src/common/constants';

import Icon from '../IconDS22';
import styles from './SocialLinks.module.scss';

const outlets = [
  ['Facebook', GMB_FACEBOOK_LINK, 'facebook'],
  ['Twitter', GMB_TWITTER_LINK, 'x-company'],
  ['Instagram', GMB_INSTAGRAM_LINK, 'instagram'],
  ['LinkedIn', GMB_LINKEDIN_LINK, 'linkedin'],
  ['TikTok', GMB_TIKTOK_LINK, 'tiktok'],
  ['Pinterest', GMB_PINTEREST_LINK, 'pinterest'],
  ['YouTube', GMB_YOUTUBE_LINK, 'youtube'],
] as const;

const SocialLinks: FC = () => (
  <ul className={styles.root}>
    {outlets.map(([name, url, icon]) => (
      <li
        key={name}
        className={styles.item}
        data-test={`${name}SocialMediaLink`}
      >
        <a
          href={url}
          className={styles.link}
          title={name}
          {...NEW_TAB_ATTRIBUTES}
        >
          <Icon
            id={`${icon}`}
            className={styles.icon}
          />
        </a>
      </li>
    ))}
  </ul>
);

export default SocialLinks;
